export default class LazyLoadImages {
  constructor(
    selector,
    attributeToLoad = 'data-src',
    attributeToChange = 'src'
  ) {
    const lazyLoadObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) {
            target.setAttribute(
              attributeToChange,
              target.getAttribute(attributeToLoad)
            )
            observer.unobserve(target)
          }
        })
      },
      {
        threshold: 1,
        rootMargin: '400px',
      }
    )

    this.lazyImages = document.querySelectorAll(selector)
    this.lazyImages.forEach((i) => lazyLoadObserver.observe(i))
  }
}
